var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"editor"},[_c('Editor',{attrs:{"id":"edit","init":_vm.init},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }